/**
 * @function scrollToAnchor
 * @param {string} anchor 
 */

const scrollToAnchor = anchor => {
  window.location.hash = '#' + anchor
}

export default scrollToAnchor
